module.exports = __webpack_public_path__ + "static/x86-mrsyphb.e11d9b1c.png";